"use client";

import { useState, useEffect } from "react";
import { getTenantFromDomain } from "@/app/lib/tenant";
import type { TenantType } from "@/types";

export const useTenant = (): TenantType | null => {
   const [tenant, setTenant] = useState<TenantType | null>(null);

   useEffect(() => {
      const domain = window.location.host;
      setTenant(getTenantFromDomain(domain));
   }, []);

   return tenant;
};
